import React, { useContext, useState } from 'react'

import Cards from '../components/Cards/Cards'

import { DBContext } from '../contexts/databases'

import './EXPScaler.scss'

function EXPScaler(props) {
	const { monster_db, monster_dbReady } = useContext(DBContext)
	const [selectedBaseLevel, setSelectedBaseLevel] = useState(1)
	const [selectedRangeLevel, setSelectedRangeLevel] = useState(0)
	const [premium, setPremium] = useState(false)
	const [selectedBattleManual, setSelectedBattleManual] = useState(1)
	const [selectedBattleManualJob, setSelectedBattleManualJob] = useState(1)
	const [selectedRaces, setSelectedRaces] = useState(new Set())
	const [selectedElements, setSelectedElements] = useState(new Set())
	const [selectedSizes, setSelectedSizes] = useState(new Set())
	let levels = []
	let rangeLevels = []
	const rangeValues = {
		515: {
			min: -5,
			max: 15,
		},
		1015: {
			min: -10,
			max: 15,
		},
		1515: {
			min: -15,
			max: 15,
		},
		2015: {
			min: -20,
			max: 15,
		},
		2515: {
			min: -25,
			max: 15,
		},
		3015: {
			min: -30,
			max: 15,
		},
	}
	const rangeString = {
		515: '100% ~ 140% exp',
		1015: '95% ~ 140% exp',
		1515: '90% ~ 140% exp',
		2015: '85% ~ 140% exp',
		2515: '60% ~ 140% exp',
		3015: '35% ~ 140% exp',
	}
	const battleManual = [0, 30, 50, 75, 100, 150, 200]
	const races = [
		'Formless',
		'Undead',
		'Brute',
		'Plant',
		'Insect',
		'Fish',
		'Demon',
		'D.Human',
		'Angel',
		'Dragon',
	]
	const elements = [
		'Neutral',
		'Water',
		'Earth',
		'Fire',
		'Wind',
		'Poison',
		'Holy',
		'Shadow',
		'Ghost',
		'Undead',
	]
	const sizes = ['Small', 'Medium', 'Large']
	for (let i = 1; i <= 200; i++) levels.push(i)
	for (let i = 0; i <= 15; i++) rangeLevels.push(i)
	Object.keys(rangeValues).map((range) => rangeLevels.push(range))

	const filterMonsters = (monster) => {
		const raceOk =
			selectedRaces.size === 0 || selectedRaces.has(monster.Race)
		const elementOk =
			selectedElements.size === 0 || selectedElements.has(monster.Element)
		const sizeOk =
			selectedSizes.size === 0 || selectedSizes.has(monster.Size)
		return (
			raceOk &&
			elementOk &&
			sizeOk &&
			monster.Level <=
				selectedBaseLevel +
					(selectedRangeLevel <= 15
						? selectedRangeLevel
						: rangeValues[selectedRangeLevel].max) &&
			monster.Level >=
				selectedBaseLevel -
					(selectedRangeLevel <= 15
						? selectedRangeLevel
						: -rangeValues[selectedRangeLevel].min)
		)
	}
	return (
		<div className='expscalerContainer'>
			<Cards Name='Monster Search'>
				<div className='options'>
					<div className='sectionTitle'>Settings</div>
					<div className='optionsSelectors'>
						<div className='baseLv subOptions'>
							<label htmlFor='BaseLevelSelector'>
								Player Lv.
							</label>
							<select
								name='BaseLevelSelector'
								id='BaseLevelSelector'
								onChange={(e) => {
									setSelectedBaseLevel(Number(e.target.value))
								}}
							>
								{levels.map((level) => (
									<option
										key={'baseLv' + level}
										value={level}
									>
										{level}
									</option>
								))}
							</select>
						</div>
						<div className='rangeLv subOptions'>
							<label htmlFor='RangeLevelSelector'>Range</label>
							<select
								name='RangeLevelSelector'
								id='RangeLevelSelector'
								onChange={(e) => {
									setSelectedRangeLevel(
										Number(e.target.value),
									)
								}}
							>
								{rangeLevels.map((level) => (
									<option
										key={'rangeLv' + level}
										value={level}
									>
										{level < 16
											? level === 0
												? 'Same level'
												: '± ' +
													level +
													(level === 1
														? 'level'
														: 'levels')
											: rangeString[level]}
									</option>
								))}
							</select>
						</div>
						<div className='premium subOptions'>
							<label htmlFor='PremiumCheckbox'>Premium</label>
							<input
								type='checkbox'
								name='PremiumCheckbox'
								id='PremiumCheckbox'
								checked={premium} // ← controlled
								onChange={(e) => {
									setPremium(e.target.checked)
								}}
							/>
						</div>
						<div className='battleManualBase subOptions'>
							<label htmlFor='battleManualBase'>
								Battle Manual
							</label>
							<select
								name='battleManualBase'
								id='battleManualBase'
								onChange={(e) => {
									setSelectedBattleManual(
										Number(e.target.value) / 100,
									)
								}}
							>
								{battleManual.map((bonus) => (
									<option
										key={'battleManualBase' + bonus}
										value={bonus}
									>
										{bonus === 0
											? 'None'
											: '+' + bonus + '%'}
									</option>
								))}
							</select>
						</div>
						<div className='battleManualJob subOptions'>
							<label htmlFor='battleManualJob'>
								Battle Manual
							</label>
							<select
								name='battleManualJob'
								id='battleManualJob'
								onChange={(e) => {
									setSelectedBattleManualJob(
										Number(e.target.value) / 100,
									)
								}}
							>
								{battleManual.map((bonus) => (
									<option
										key={'battleManualJob' + bonus}
										value={bonus}
									>
										{bonus === 0
											? 'None'
											: '+' + bonus + '%'}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className='options'>
						<div className='sectionTitle'>Monsters Filters</div>
						<div className='monsterFiltersGrid'>
							{/* <div className='races optionsSelectors'> */}
							{races.map((race) => (
								<div
									className={race + 'checkbox subOptions'}
									key={race + 'checkbox subOptions'}
								>
									<label htmlFor={race + 'checkbox'}>
										{race}
									</label>
									<input
										type='checkbox'
										name={race + 'checkbox'}
										id={race + 'checkbox'}
										checked={selectedRaces.has(race)} // ← controlled
										onChange={(e) => {
											const newSet = new Set(
												selectedRaces,
											)
											if (e.target.checked) {
												newSet.add(race)
											} else {
												newSet.delete(race)
											}
											setSelectedRaces(newSet)
										}}
									/>
								</div>
							))}
							{/* </div> */}
							{/* <div className='elements optionsSelectors'> */}
							{elements.map((element) => (
								<div
									className={element + 'checkbox subOptions'}
									key={element + 'checkbox subOptions'}
								>
									<label
										htmlFor={'ele' + element + 'checkbox'}
									>
										{element}
									</label>
									<input
										type='checkbox'
										name={'ele' + element + 'checkbox'}
										id={'ele' + element + 'checkbox'}
										checked={selectedElements.has(element)}
										onChange={(e) => {
											const newSet = new Set(
												selectedElements,
											)
											if (e.target.checked) {
												newSet.add(element)
											} else {
												newSet.delete(element)
											}
											setSelectedElements(newSet)
										}}
									/>
								</div>
							))}
							{/* </div> */}
							{/* <div className='sizes optionsSelectors'> */}
							{sizes.map((size) => (
								<div
									className={size + 'checkbox subOptions'}
									key={size + 'checkbox subOptions'}
								>
									<label htmlFor={size + 'checkbox'}>
										{size}
									</label>
									<input
										type='checkbox'
										name={size + 'checkbox'}
										id={size + 'checkbox'}
										checked={selectedSizes.has(size)} // ← controlled
										onChange={(e) => {
											const newSet = new Set(
												selectedSizes,
											)
											if (e.target.checked) {
												newSet.add(size)
											} else {
												newSet.delete(size)
											}
											setSelectedSizes(newSet)
										}}
									/>
								</div>
							))}
							{/* </div> */}
						</div>
					</div>
				</div>
				<div>
					<table className='MonsterTable'>
						<tbody>
							<tr>
								<th>Name</th>
								<th>Level</th>
								<th>EXP (Base)</th>
								<th>EXP (Job)</th>
								<th>HP</th>
								<th>Race</th>
								<th>Element</th>
								<th>Size</th>
								<th>100% Hit</th>
								<th>95% Flee</th>
								<th>Def</th>
								<th>Mdef</th>
							</tr>

							{monster_dbReady ? (
								monster_db
									.filter((monster) =>
										filterMonsters(monster),
									)
									.map((monster) => (
										<tr key={monster.Id}>
											<td className='MonsterName'>
												{monster.Name}
											</td>
											<td>{monster.Level}</td>
											<td>
												{Math.floor(
													(monster.BaseExp
														? monster.BaseExp
														: 0) *
														(1 +
															(premium
																? 0.5
																: 0) +
															selectedBattleManual),
												)}
											</td>
											<td>
												{Math.floor(
													(monster.JobExp
														? monster.JobExp
														: 0) *
														(1 +
															(premium
																? 0.5
																: 0) +
															selectedBattleManualJob),
												)}
											</td>
											<td>{monster.Hp}</td>
											<td>{monster.Race}</td>
											<td>
												{monster.Element +
													' ' +
													monster.ElementLevel}
											</td>
											<td>{monster.Size}</td>
											<td>
												{200 +
													monster.Level +
													(monster.Agi
														? monster.Agi
														: 0)}
											</td>
											<td>
												{170 +
													monster.Level +
													(monster.Dex
														? monster.Dex
														: 0)}
											</td>
											<td>{monster.Defense}</td>
											<td>
												{console.log(monster)}
												{monster.MagicDefense
													? monster.MagicDefense
													: 0}
											</td>
										</tr>
									))
							) : (
								<tr>
									<td>Loading monster DB</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</Cards>
		</div>
	)
}

export default EXPScaler
